import angular from 'angular';
import _ from 'lodash';

import SubEntity from '../data/seller/sub-entity.data';
import moment from 'moment';

(function () {
    'use strict';
    angular.module('app.core').factory('PrincipalsDA', PrincipalsDA);

    PrincipalsDA.$inject = [
        '$q',
        '$log',
        '$http',
        'logger',
        'Restangular',
        'Upload',
        'CONF',
        'PRINCIPAL',
        'UtilSvc',
        'PrincipalDetail',
        'PrincipalKiss',
        'PrincipalEpdf',
        'LegalEntity',
        'LegalEntityPerimeter',
        'PrincipalInvitedEntity',
        'Invitation',
        'Report',
        'LegalEntityGroup',
        'LegalEntityGroupList',
        'UserBo',
        '$translate',
        'PrincipalBuyer',
        'Brand',
        'Document',
        'IMPORTTYPE'
    ];

    /**
     * Class permettant la manipulation des infos realtives au donneur d'ordre
     */

    /* @ngInject */
    function PrincipalsDA(
        $q,
        $log,
        $http,
        logger,
        Restangular,
        Upload,
        CONF,
        PRINCIPAL,
        UtilSvc,
        PrincipalDetail,
        PrincipalKiss,
        PrincipalEpdf,
        LegalEntity,
        LegalEntityPerimeter,
        PrincipalInvitedEntity,
        Invitation,
        Report,
        LegalEntityGroup,
        LegalEntityGroupList,
        UserBo,
        $translate,
        PrincipalBuyer,
        Brand,
        Document,
        IMPORTTYPE
    ) {
        var baseUrl = CONF.apiBaseUrl + '/v1/principals';
        var baseUrlLegalEntity = CONF.apiBaseUrl + '/v1/legal-entity';
        var baseUrlEntityGroup = CONF.apiBaseUrl + '/v1/entity-groups';
        var baseUrlUpload = CONF.apiContext + CONF.apiBaseUrl + '/v1/' + 'principals';
        var baseUrlSubEntity = CONF.apiBaseUrl + '/v1/' + 'legal-entity/sub-entity';
        var baseUrlCgv = CONF.apiBaseUrl + '/v1/documents';
        var baseUrlImport = CONF.apiBaseUrl + '/v1/principals/import';
        var baseUrlImportWithContext = CONF.apiContext + CONF.apiBaseUrl + '/v1/principals/import';
        var FileSaver = require('file-saver');
        var baseUrlPdp = CONF.apiBaseUrl + '/v1/platform-partner-history';
        var baseUrlOffreApi = CONF.apiBaseUrl + '/v1/offers-api';
        var baseUrlPdfGeneration = CONF.apiBaseUrl + '/v1/pdf-generation';
        var baseUrlAcquittal = CONF.apiBaseUrl + '/v1/acquittal';


        var exports = {
            getPrincipal: getPrincipal,
            getPrincipalCheckConfigStats: getPrincipalCheckConfigStats,
            execPrincipalCheckConfig: execPrincipalCheckConfig,
            createPrincipal: createPrincipal,
            updatePrincipal: updatePrincipal,
            checkDuplicateEid: checkDuplicateEid,
            checkDuplicateAppId: checkDuplicateAppId,
            getStatus: getStatus,
            getUnsentNotifsNumber: getUnsentNotifsNumber,
            listCompanies: listCompanies,
            listSellers: listSellers,
            searchSellers: searchSellers,
            searchBuyers: searchBuyers,
            importStandardCompanies: importStandardCompanies,
            importKissCompanies: importKissCompanies,
            importEpdfCompanies: importEpdfCompanies,
            companySignOut: companySignOut,
            importSellers: importSellers,
            importBuyers: importBuyers,
            importRelations: importRelations,
            importBuyersRelations: importBuyersRelations,
            sendNotifications: sendNotifications,
            sendBuyersNotifications: sendBuyersNotifications,
            execCsvEditique: execCsvEditique,
            getLegalEntity: getLegalEntity,
            searchPrincipals: searchPrincipals,
            searchCompanies: searchCompanies,
            updateLegalEntity: updateLegalEntity,
            importEmailTemplate: importEmailTemplate,
            getEmailTemplate: getEmailTemplate,
            createLegalEntity: createLegalEntity,
            getInvitation: getInvitation,
            getBuyerInvitation: getBuyerInvitation,
            searchSellersByNameOrId: searchSellersByNameOrId,
            searchBuyersByNameOrId: searchBuyersByNameOrId,
            searchReports: searchReports,
            execExportReminder: execExportReminder,
            getExportReminder: getExportReminder,
            isPrincipalDeletable: isPrincipalDeletable,
            deletePrincipal: deletePrincipal,
            searchGroups: searchGroups,
            createGroup: createGroup,
            getGroup: getGroup,
            updateGroup: updateGroup,
            searchUsers: searchUsers,
            saveUser: saveUser,
            isUserSingleAdminFo: isUserSingleAdminFo,
            autoCompleteGetAllSubEntityDOPermiter: autoCompleteGetAllSubEntityDOPermiter,
            hasSellerInvited: hasSellerInvited,
            getLegalEntityAndSubEntityForGroup: getLegalEntityAndSubEntityForGroup,
            createGroupSubEntity: createGroupSubEntity,
            updateGroupSubEntity: updateGroupSubEntity,
            listPrincipals: listPrincipals,
            checkGisPlatformId: checkGisPlatformId,
            checkGisCompanyDetail: checkGisCompanyDetail,
            hasAcceptedInvitations: hasAcceptedInvitations,
            getSubEntity: getSubEntity,
            updateSubEntity: updateSubEntity,
            createSubEntity: createSubEntity,
            getCgvOfSubEntity: getCgvOfSubEntity,
            getCgvPdf: getCgvPdf,
            uploadCgvPdf: uploadCgvPdf,
            deleteCgvDoc: deleteCgvDoc,
            uploadAndDeployClientResource:uploadAndDeployClientResource,
            deleteClientResourceVersion: deleteClientResourceVersion,
            downloadClientResourceVersion: downloadClientResourceVersion,
            getClientResourceVersions: getClientResourceVersions,
            getBrand: getBrand,
            exportInvitedBuyersFollowUp: exportInvitedBuyersFollowUp,
            countInvitedBuyersFollowUpNotifiedWithDate: countInvitedBuyersFollowUpNotifiedWithDate,
            exportConfDo: exportConfDo,
            checkImportConfDo: checkImportConfDo,
            importConfDo: importConfDo,
            canHaveSalesAdmin: canHaveSalesAdmin,
            getAllReferentialsOfPrincipal: getAllReferentialsOfPrincipal,
            saveAllReferentials: saveAllReferentials,
            findReferentialsOfCommunitiesByIds: findReferentialsOfCommunitiesByIds,
            getDocumentarySpace: getDocumentarySpace,
            updateDocumentarySpace: updateDocumentarySpace,
            deleteDocumentarySpace: deleteDocumentarySpace,
            checkAndSaveDocumentarySpace: checkAndSaveDocumentarySpace,
            getAllDematPlatforms: getAllDematPlatforms,
            checkAppIdExist: checkAppIdExist,
            createOrUpdatePdp: createOrUpdatePdp,
            createOrUpdateSubEntPdp: createOrUpdateSubEntPdp,
            createOrUpdateRoutingCodePdp: createOrUpdateRoutingCodePdp,
            checkFacturXExchangeDirectoryExistence: checkFacturXExchangeDirectoryExistence,
            importBuyerSubEntitiesRelations: importBuyerSubEntitiesRelations,
            getOffresApi:getOffresApi,
            addOfferApi:addOfferApi,
            getAcquittal:getAcquittal,
            addAcquittal:addAcquittal,
            getLegalEntityContext:getLegalEntityContext,
            getOffresApiForLegalEntity:getOffresApiForLegalEntity,
            hasCommunityHandlingStockSoftware: hasCommunityHandlingStockSoftware,
        };

        return exports;

        ////////////////
        function listPrincipals() {
            return Restangular.one(baseUrl).oneUrl('buyerOrSeller').getList();
        }

        function autoCompleteGetAllSubEntityDOPermiter(val) {
            return Restangular.all(baseUrl)
                .all(val.id)
                .all('allsubentities')
                .all('autocomplete')
                .post(val)
                .then(function (data) {
                    return _.map(data, function (data) {
                        return new SubEntity(data, $translate);
                    });
                });
        }

        function getPrincipal(principalId) {
            return Restangular.one(baseUrl, principalId)
                .get()
                .then(function (data) {
                    return {
                        detail: new PrincipalDetail(data.detail),
                        kiss: new PrincipalKiss(data.kiss),
                        epdf: new PrincipalEpdf(data.epdf),
                        buyer: new PrincipalBuyer(data.buyer),
                    };
                });
        }

        /**
         * Recherche le détail d'une société.
         */
        function getLegalEntity(principalId, legalEntityId) {
            return Restangular.one(baseUrl, principalId)
                .all('companies')
                .all(legalEntityId)
                .customGET()
                .then(function (data) {
                    return new LegalEntity(data);
                });
        }

        /**
         * Création du principal
         */
        function createPrincipal(principal) {
            var _principal = _preparePrincData(angular.copy(principal));
            return Restangular.all(baseUrl).customPOST(_principal);
        }

        /**
         * Mise à jour du principal
         */
        function updatePrincipal(principal) {
            var _principal = _preparePrincData(angular.copy(principal));
            return Restangular.all(baseUrl)
                .customPUT(_principal)
                .then(function (data) {
                    $log.log('updatePrincipal:data', data);
                    return {
                        detail: new PrincipalDetail(data.detail),
                        kiss: new PrincipalKiss(data.kiss),
                        epdf: new PrincipalEpdf(data.epdf),
                        buyer: new PrincipalBuyer(data.buyer),
                    };
                });
        }

        function _preparePrincData(principal) {
            if (principal.detail) {
                principal.detail.prepareForServer();
            }
            if (principal.kiss && principal.kiss.paramKiss) {
                principal.kiss.prepareForServer();
            } else {
                principal.kiss = null;
            }
            if (principal.epdf && principal.epdf.paramEpdf) {
                principal.epdf.prepareForServer();
            } else {
                principal.epdf = null;
            }
            if (principal.buyer && principal.buyer.paramBuyer) {
                principal.buyer.prepareForServer();
            } else {
                principal.buyer = null;
            }
            return principal;
        }

        /**
         * Vérifiaction de l'unicité de l'EID saisi lors de la création du DO
         */
        function checkDuplicateEid(principalEid) {
            return Restangular.one(baseUrl).all('check-eid').post({ value: principalEid });
        }
        /**
         * Vérifiaction de l'unicité de l'AppID saisi lors de la création du DO
         */
        function checkDuplicateAppId(principalEid) {
            return Restangular.one(baseUrl).all('check-appid').post({ value: principalEid });
        }

        /**
         * Vérifiaction de l'existence de l'AppId saisi.
         */
        function checkAppIdExist(principalEid) {
            return Restangular.one(baseUrl).customPOST(
                { value: principalEid },
                'check-appid',
                { checkOption: 'EXIST' },
                {}
            );
        }

        /**
         * Récupération du status de création du principal
         */
        function getStatus(principalId) {
            return Restangular.one(baseUrl, principalId).oneUrl('status').get();
        }

        /**
         * Récupération du nombre de notifs non envoyées pour les clients d'un DO
         */
        function getUnsentNotifsNumber(principalId) {
            return Restangular.one(baseUrl, principalId).oneUrl('buyers-invitations-unsent').get();
        }

        /**
         * Liste les sociétés d'un donneur d'ordres.
         */
        function listCompanies(principalId) {
            return Restangular.one(baseUrl, principalId)
                .all('companies')
                .getList()
                .then(function (companies) {
                    return _.map(companies, function (company) {
                        return new LegalEntity(company);
                    });
                });
        }

        /**
         * Liste les fournisseurs d'un donneur d'ordres.
         */
        function listSellers(principalId) {
            return Restangular.one(baseUrl, principalId)
                .all('sellers')
                .getList()
                .then(function (sellers) {
                    return _.map(sellers, function (s) {
                        return new LegalEntity(s);
                    });
                });
        }

        /**
         * Recherche des fournisseurs d'un donneur d'ordres.
         */
        function searchSellers(principalId, sellersFilter) {
            return Restangular.one(baseUrl, principalId)
                .all('sellersByCriteria')
                .post(sellersFilter)
                .then(function (pageSellers) {
                    return {
                        page: pageSellers.page,
                        totalItems: pageSellers.totalElements,
                        sellers: _.map(pageSellers.content, function (s) {
                            return new PrincipalInvitedEntity(s);
                        }),
                    };
                });
        }

        /**
         * Recherche des clients d'un donneur d'ordres.
         */
        function searchBuyers(principalId, buyersFilter) {
            return Restangular.one(baseUrl, principalId)
                .all('buyersByCriteria')
                .post(buyersFilter)
                .then(function (pageBuyers) {
                    return {
                        page: pageBuyers.page,
                        totalItems: pageBuyers.totalElements,
                        buyers: _.map(pageBuyers.content, function (s) {
                            return new PrincipalInvitedEntity(s);
                        }),
                    };
                });
        }

        /**
         * Import du fichier CSV pour les sociétés ne nécessitant pas de création de containers.
         */
        function importStandardCompanies(criteria) {
            return _importCompanies(criteria, 'standard-companies/import');
        }

        /**
         * Import du fichier CSV pour les sociétés KISS
         */
        function importKissCompanies(criteria) {
            return _importCompanies(criteria, 'kiss-companies/import');
        }

        /**
         * Import du fichier CSV pour les sociétés EPDF
         */
        function importEpdfCompanies(criteria) {
            return _importCompanies(criteria, 'epdf-companies/import');
        }

        /**
         * Import du fichier CSV pour les fournisseurs
         */
        function importSellers(data) {
            return _import(data.principalId, data.file, 'referentials/' + IMPORTTYPE.sellers + '/import');
        }

        /**
         * Import du fichier CSV pour les fournisseurs
         */
        function importBuyers(data) {
            return _import(data.principalId, data.file, 'referentials/' + IMPORTTYPE.buyers + '/import');
        }

        /**
         * Import du fichier CSV pour les relation commerciales
         */
        function importRelations(data) {
            return _import(data.principalId, data.file, 'referentials/' + IMPORTTYPE.relations + '/import');
        }

        /**
         * Import du fichier CSV pour les relation commerciales DO/Clients invités
         */
        function importBuyersRelations(data) {
            return _import(data.principalId, data.file, 'referentials/' + IMPORTTYPE.buyers_relations + '/import');
        }

        /**
         *   Import du fichier CSV pour les relations commerciales des établissements de la société DO et des établissements des clients invités.
         */
        function importBuyerSubEntitiesRelations(data) {
            return _import(data.principalId, data.file, 'referentials/' + IMPORTTYPE.buyer_sub_entities_relations + '/import');
        }

        /**
         * Import du fichier ZIP contenant les templates email
         */
        function importEmailTemplate(data) {
            return _import(data.principalId, data.file, 'email-template/import', data.type);
        }

        /**
         * Récupérer le template email
         */
        function getEmailTemplate(data) {
            return Restangular.one(baseUrl, data.principalId)
                .all('email-template-search')
                .all(data.fileName)
                .customGET()
                .then(function (response) {
                    return response;
                });
        }

        /**
         * Méthode d'import des sociétés
         */
        function _importCompanies(criteria, type) {
            return Upload.upload({
                url: baseUrlUpload + '/' + criteria.principalId + '/' + type,
                data: {
                    file: criteria.file,
                    createDematAccount: criteria.createDematAccount,
                },
            });
        }

        /**
         * Méthode d'import générique
         */
        function _import(principalId, file, url, type) {
            return Upload.upload({
                url: baseUrlUpload + '/' + principalId + '/' + url + (type ? '/' + type : ''),
                data: {
                    file: file,
                },
            });
        }

        /**
         * Envoi des notifications
         */
        function sendNotifications(principalId, type) {
            return Restangular.one(baseUrl, principalId).oneUrl('notifications').oneUrl('send').oneUrl(type).get();
        }

        /**
         * Envoi des notifications clients invités
         */
        function sendBuyersNotifications(principalId, type) {
            return Restangular.one(baseUrl, principalId)
                .oneUrl('buyers-notifications')
                .oneUrl('send')
                .oneUrl(type)
                .get();
        }

        /**
         * Récupération du fichier CSV permettant de générer l'editique
         */
        function execCsvEditique(principalId) {
            return Restangular.one(baseUrl, principalId)
                .oneUrl('notifications')
                .oneUrl('send')
                .oneUrl('editique')
                .get()
                .then(function (data) {
                    return data;
                });
        }

        function execPrincipalCheckConfig(principalId) {
            return Restangular.one(baseUrl, principalId)
                .oneUrl('checkConfig')
                .get()
                .then(function (data) {
                    return data;
                });
        }

        function getPrincipalCheckConfigStats(principalId) {
            return Restangular.one(baseUrl, principalId).oneUrl('checkConfigStats').get();
        }

        /**
         * Recherche des principals par nom ou eid pour un fournisseur.
         */
        function searchPrincipals(searchValue) {
            return Restangular.oneUrl(baseUrl)
                .all('search')
                .post({ value: searchValue })
                .then(function (pagePrincipalsDetail) {
                    return _.map(pagePrincipalsDetail.content, function (p) {
                        return new PrincipalDetail(p);
                    });
                });
        }

        /**
         * Recherche des sociétés par identifiants fiscal ou national ou par nom.
         */
        function searchCompanies(searchValue) {
            return Restangular.oneUrl(baseUrl)
                .all('search-companies')
                .post({ value: searchValue })
                .then(function (pageLegalEntities) {
                    return _.map(pageLegalEntities.content, function (l) {
                        return new LegalEntity(l);
                    });
                });
        }

        /**
         * Met à jour la sosciété.
         */
        function updateLegalEntity(criteria, principalId) {
            return Restangular.oneUrl(baseUrl)
                .all(principalId)
                .all('companies')
                .all(criteria.legalEntity.id)
                .customPOST(criteria);
        }

        /**
         * Crée une sosciété.
         */
        function createLegalEntity(legalEntityCreationData, principalId) {
            return Restangular.oneUrl(baseUrl).all(principalId).all('companies').customPOST(legalEntityCreationData);
        }

        /**
         * Récupération d'une invitation fournisseur.
         */
        function getInvitation(invitationId) {
            return Restangular.oneUrl(baseUrl)
                .one('invitations', invitationId)
                .get()
                .then(function (response) {
                    return new Invitation(response);
                });
        }

        /**
         * Récupération d'une invitation cliente.
         */
        function getBuyerInvitation(invitationId) {
            return Restangular.oneUrl(baseUrl)
                .one('invitation-buyer', invitationId)
                .get()
                .then(function (response) {
                    return new Invitation(response);
                });
        }

        /**
         * Recherche des fournisseurs d'un donneur d'ordres par nom ou par identifiant.
         */
        function searchSellersByNameOrId(principalId, searchValue) {
            return Restangular.one(baseUrl, principalId)
                .all('sellersByNameOrId')
                .post({ value: searchValue })
                .then(function (sellers) {
                    return _.map(sellers.content, function (s) {
                        return new PrincipalInvitedEntity(s);
                    });
                });
        }

        /**
         * Recherche des clients d'un donneur d'ordres par nom ou par identifiant.
         */
        function searchBuyersByNameOrId(principalId, searchValue) {
            return Restangular.one(baseUrl, principalId)
                .all('buyersByNameOrId')
                .post({ value: searchValue })
                .then(function (buyers) {
                    return _.map(buyers.content, function (s) {
                        return new PrincipalInvitedEntity(s);
                    });
                });
        }

        /**
         * Recherche des rapports d'un donneur d'ordres.
         */
        function searchReports(principalId, reportFilter) {
            var filter = reportFilter.preparBeforeSearch();
            return Restangular.one(baseUrl, principalId)
                .all('reports-by-criteria')
                .post(filter)
                .then(function (reportsData) {
                    return {
                        totalItems: reportsData.totalElements,
                        reports: _.map(reportsData.content, function (s) {
                            return new Report(s);
                        }),
                    };
                });
        }

        function execExportReminder(principalId, type) {
            return Restangular.one(baseUrl, principalId)
                .oneUrl('notifications')
                .oneUrl('reminder')
                .one('editique', type)
                .get()
                .then(function (data) {
                    return data;
                });
        }

        function getExportReminder(type, principalId, fileId) {
            return Restangular.setFullResponse(true)
                .one(CONF.apiBaseUrl + '/v1/files', fileId)
                .get()
                .then(function (data) {
                    var contentDisposition = data.headers('content-disposition');

                    var filename = 'RPT-' + principalId + '_SUB_NAME_' + UtilSvc.getDateForExportName() + '.csv';
                    var subname = type === 'no_email' ? 'RELANCES_SANS_EMAIL' : 'RELANCES';
                    filename = filename.replace('_SUB_NAME_', subname);

                    if (contentDisposition) {
                        var filenameSeg = 'filename=';
                        var filenameSegIdx = contentDisposition.indexOf(filenameSeg) + filenameSeg.length;
                        var filenameStartIdx = contentDisposition.indexOf('"', filenameSegIdx) + 1;
                        var filenameEndIdx = contentDisposition.indexOf('"', filenameStartIdx);
                        filename = contentDisposition.substring(filenameStartIdx, filenameEndIdx);
                    }
                    var blob = new Blob([data.data], {
                        type: 'text/plain;charset=utf-8',
                    });
                    FileSaver.saveAs(blob, filename);
                    Restangular.setFullResponse(false);
                    return data;
                });
        }

        /**
         * Teste si le DO est supprimable.
         * @param principalId Identifiant du DO
         */
        function isPrincipalDeletable(principalId) {
            return Restangular.one(baseUrl, principalId).one('deletable').get();
        }
        /**
         *  Teste si le DO a au moins une invitation qui a été accepter
         * @param principalId Identifiant du DO
         */
        function hasAcceptedInvitations(principalId) {
            return Restangular.one(baseUrl, principalId).one('has-accepted-invitation').get();
        }

        /**
         * Supprime le DO.
         */
        function deletePrincipal(principalId) {
            return Restangular.one(baseUrl, principalId).remove();
        }

        /**
         * Recherche les groupes du DO suivant des critères.
         */
        function searchGroups(principalId, criteria) {
            return Restangular.one(baseUrl, principalId)
                .all('searchGroups')
                .post(criteria)
                .then(function (groups) {
                    return _.map(groups, function (group) {
                        return new LegalEntityGroupList(group);
                    });
                });
        }

        /**
         * Recherche les groupes du DO suivant des critères.
         * @param principalid Identifiant du DO
         * @param criteria détails du groupe
         */
        function createGroup(principalId, criteria) {
            return Restangular.one(baseUrl, principalId).all('group').customPUT(criteria);
        }

        /**
         * Récupère un groupe via son id.
         * @param principalId Identifiant du DO
         * @param groupId Identifiant du groupe
         */
        function getGroup(principalId, groupId) {
            return Restangular.one(baseUrl, principalId)
                .all('group')
                .all(groupId)
                .customGET()
                .then(function (group) {
                    return new LegalEntityGroup(group);
                });
        }

        /**
         * Récupère un groupe via son id.
         * @param principalId Identifiant du DO
         * @param groupId Identifiant du groupe
         */
        function getLegalEntityAndSubEntityForGroup(groupId) {
            return Restangular.one(baseUrlEntityGroup)
                .all(groupId)
                .customGET()
                .then(function (group) {
                    return new LegalEntityGroup(group);
                });
        }

        /**
         * Modifie un groupe.
         *
         * @param principalId Identifiant du DO
         * @param groupId Identifiant du groupe à modifier
         * @param criteria détails du groupe
         */
        function updateGroup(principalId, groupId, criteria) {
            return Restangular.one(baseUrl, principalId)
                .all('group')
                .all(groupId)
                .post(criteria)
                .then(function (group) {
                    return new LegalEntityGroup(group);
                });
        }

        /**
         * Recherche d'utilisateurs
         *
         * @param {number} principalId - Identifiant de donneur d'ordre.
         * @param {UsersFilter} usersFilter - critères de recherche des utilisateurs
         */
        function searchUsers(principalId, usersFilter) {
            return Restangular.one(baseUrl, principalId)
                .all('usersByCriteria')
                .post(usersFilter)
                .then(pageUsers => {
                    return {
                        totalItems: pageUsers.totalElements,
                        users: _.map(pageUsers.content, u => {
                            return new UserBo(u);
                        }),
                    };
                });
        }

        /**
         * Sauvegarde d'un utilisateur pour le donneur d'ordres.
         * @param {number} principalId - identifiant du donneur d'ordres.
         * @param {json} user - les données de l'utilisateur à créer.
         */
        function saveUser(principalId, user) {
            return Restangular.one(baseUrl, principalId).all('save-user').post(user);
        }

        /**
         * Nous dit si un utilisateur est l'unique admin d'un donneur d'ordres.
         * @param {number} principalId - identifiant du donneur d'ordres.
         * @param {string} userId - login de l'utisateur
         */
        function isUserSingleAdminFo(principalId, userId) {
            return Restangular.one(baseUrl, principalId).all('users').all(userId).oneUrl('is-single-admin').get();
        }

        /**
         * Indique si l'entreprise a des fournisseurs en cours d'invitation
         * @param principalId Identifiant de l'entreprise
         */
        function hasSellerInvited(principalId) {
            return Restangular.one(baseUrl, principalId).all('has-seller-invited').customGET();
        }

        /**
         *  Permet la creation d'un groupe d'etablisment
         * @param {*} data
         */
        function createGroupSubEntity(data) {
            return Restangular.all(baseUrlEntityGroup)
                .post(data)
                .then(function (group) {
                    return new LegalEntityGroup(group);
                });
        }

        /**
         * Permet la Mise a jour d'un groupe d'etablisment
         * @param {*} data
         */
        function updateGroupSubEntity(data) {
            return Restangular.all(baseUrlEntityGroup)
                .customPUT(data)
                .then(function (group) {
                    return new LegalEntityGroup(group);
                });
        }

        function checkGisPlatformId(legalEntity, principalId) {
            return Restangular.all(baseUrl)
                .all(principalId)
                .all('checkGisPlatformId')
                .post(legalEntity)
                .then(function (data) {
                    return data;
                });
        }

        /**
         * Contrôle de cohérence entre les données saisies et les données de la plateforme GIS lors de la création du DO
         */
        function checkGisCompanyDetail(platformEid, codeDO) {
            return Restangular.one(baseUrl).one('demat-platform', platformEid).one('checkGisCompany', codeDO).get();
        }

        function getSubEntity(id) {
            return Restangular.all(baseUrlSubEntity)
                .one(id)
                .get()
                .then(function (data) {
                    return data;
                });
        }

        function getCgvOfSubEntity(subEntityId) {
            return Restangular.one(baseUrlCgv + '/cgv' + '/' + subEntityId)
                .get()
                .then(function (data) {
                    return _.map(data, function (s) {
                        return new Document(s);
                    });
                });
        }

        function uploadCgvPdf(document, subEntityId) {
            return Upload.upload({
                url: CONF.apiContext + baseUrlCgv + '/upload/cgv',
                data: {
                    file: document.file,
                    version: document.version,
                    subEntityId: subEntityId,
                    applicationDate: moment(document.applicationDate).format('DD/MM/YYYY'),
                },
            }).then(
                function (data) {
                    return data;
                },
                function (error) {
                    return error;
                }
            );
        }

        function getCgvPdf(documentId) {
            return $http({
                method: 'GET',
                url: CONF.apiContext + baseUrlCgv + '/' + documentId + '/document',
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer',
            }).then(function (response) {
                var blob = new Blob([response.data], {
                    type: 'application/binary',
                });
                FileSaver.saveAs(blob, 'cgv.pdf');
                return response;
            });
        }

        /**
         * supprimer document cgv
         * @param documentId Id document
         */
        function deleteCgvDoc(documentId) {
            return Restangular.one(baseUrlCgv).one('delete-cgv', documentId).remove();
        }
        function updateSubEntity(subEntityDto) {
            return Restangular.all(baseUrlSubEntity).customPOST(subEntityDto);
        }
        function createSubEntity(subEntityDto,legalEntityId) {
            return Restangular.all( `${baseUrlLegalEntity}/${legalEntityId}/sub-entity`).post(subEntityDto);
        }

        function getBrand(principalId) {
            return Restangular.one(baseUrl, principalId)
                .one('brand')
                .get()
                .then(function (data) {
                    return new Brand(data);
                });
        }

        function exportInvitedBuyersFollowUp(principalId, onlyNullEmails) {
            return Restangular.one(baseUrl, principalId)
                .one('buyers-invited-followup')
                .customPOST({ value: onlyNullEmails });
        }

        function countInvitedBuyersFollowUpNotifiedWithDate(principalId) {
            return Restangular.one(baseUrl, principalId).one('buyers-invited-followup/count').get();
        }

        function exportConfDo(principalId, modulesToExport) {
            return Restangular.one(baseUrl, principalId).one('export-config').customPOST(modulesToExport);
        }

        function checkImportConfDo(zipFile) {
            return Upload.upload({
                url: baseUrlImportWithContext + '/check',
                data: {
                    file: zipFile,
                },
            });
        }

        function importConfDo(resultImportDto) {
            return Restangular.one(baseUrlImport).one('load').customPOST(resultImportDto);
        }
        /**
         * Indique si le DO fournisseur (process O2C activé) peut avoir le role Administrateur des ventes
         */
        function canHaveSalesAdmin(principalId) {
            return Restangular.one(baseUrl, principalId).all('users').oneUrl('can-have-sales-admin').get();
        }

        /**
         * Récupère la liste des référentiels data repo d'un DO
         * @param querySearchCriteria critères de recherche
         */
        function getAllReferentialsOfPrincipal(querySearchCriteria) {
            return Restangular.one(baseUrl, querySearchCriteria.principalId)
                .all('referentials')
                .post(querySearchCriteria);
        }

        /**
         * Enregistrer la liste des référentiels data repo d'un DO
         * @param referentials critères de recherche
         */
        function saveAllReferentials(principalId, referentials) {
            return Restangular.one(baseUrl, principalId).all('referentials').one('saveAll').customPOST(referentials);
        }

        /**
         * Récupère la liste des communautés pour lesquelles les sociétés DO adhèrent
         * @param companyIds Ids des sociétés DO
         * @param principalId Id DO
         */
        function findReferentialsOfCommunitiesByIds(principalId, companyIds) {
            return Restangular.one(baseUrl, principalId).all('referentials').one('communities').customPOST(companyIds);
        }

        /**
         * Récupération de l'espace documentaire du DO
         * @param principalId Id DO
         */
        function getDocumentarySpace(principalId) {
            return Restangular.one(baseUrl, principalId).one('documentary-space').get();
        }

        /**
         * vérification et création de l'espace documentaire du DO
         * @param principalId Id DO
         * @param documentarySpace l'objet documentarySpace ( typeCode, typeLabel, id , desc )
         * @param doCheckCompaniesDocumentarySpace boolean qui indique s'il faut vérifier si les sociétés du DO ont un espace documentaire
         */
        function checkAndSaveDocumentarySpace(principalId, documentarySpace, doCheckCompaniesDocumentarySpace) {
            return Restangular.one(baseUrl, principalId).customPOST(
                documentarySpace,
                'documentary-space',
                { doCheckCompaniesDocumentarySpace: doCheckCompaniesDocumentarySpace },
                {}
            );
        }

        /**
         * mettre à jour l'espace documentaire du DO
         * @param principalId Id DO
         * @param documentarySpace l'objet documentarySpace ( typeCode, typeLabel, id , desc )
         */
        function updateDocumentarySpace(principalId, documentarySpace) {
            return Restangular.one(baseUrl, principalId).customPOST(documentarySpace, 'documentary-space/update');
        }

        /**
         * supprimer l'espace documentaire du DO
         * @param principalId Id DO
         * @param documentarySpace l'objet documentarySpace ( typeCode, typeLabel, id , desc )
         */
        function deleteDocumentarySpace(principalId, documentarySpace) {
            return Restangular.one(baseUrl, principalId).customPOST(documentarySpace, 'documentary-space/delete');
        }

        /**
         * Détache une société du DO
         * @param principalId   Identifiant du DO
         * @param companyId     Identifiant de la société
         */
        function companySignOut(principalId, companyId) {
            return Restangular.one(baseUrl, principalId).customPOST(companyId, 'company-sign-out');
        }
        function hasCommunityHandlingStockSoftware(legalEntityId) {
            return Restangular.one(baseUrlLegalEntity).oneUrl(`/${legalEntityId}/check-community-software`).customPOST();
        }

        /**
         * Retourne toutes les plateformes de démat disponibles.
         */
        function getAllDematPlatforms() {
            return Restangular.one(baseUrl).oneUrl('demat-platforms').get();
        }



        function createOrUpdatePdp(legalEntitiesIdsPdp, sens) {
            return Restangular.all(baseUrlPdp + '/' + sens).post(legalEntitiesIdsPdp)
                .then(function(response) {
                    // Transforme l'objet filtré en une liste de paires clé-valeur
                    return Object.entries(response.errors).map(([key, value]) => ({ key, value }));
                })

        }

        function createOrUpdateSubEntPdp(subEntitiesIdsPdp) {
            return Restangular.all(baseUrlPdp + '/sub-entity-re').post(subEntitiesIdsPdp).then(function(response) {
                // Transforme l'objet filtré en une liste de paires clé-valeur
                return Object.entries(response.errors).map(([key, value]) => ({ key, value }));
            });
        }

        function createOrUpdateRoutingCodePdp(routingCodesIdsPdp) {
            return Restangular.all(baseUrlPdp + '/routing-code-re').post(routingCodesIdsPdp).then(function(response) {
                // Transforme l'objet filtré en une liste de paires clé-valeur
                return Object.entries(response.errors).map(([key, value]) => ({ key, value }));
            });
        }

        function checkFacturXExchangeDirectoryExistence(platformPathFacturX) {
            return Restangular.one(baseUrl)
                .all('/check-facturx-exchange-directory-existence')
                .customGET('', { platformPathFacturX: platformPathFacturX });
        }
        function  getOffresApi (principalId){
            return Restangular.one(baseUrlOffreApi, principalId)
                .all('/')
                .customGET()
                .then(function (response) {
                    return response;
                });
        }

        function  getOffresApiForLegalEntity (principalId){
            return Restangular.one(baseUrlOffreApi, principalId)
                .all('/legalEntity')
                .customGET()
                .then(function (response) {
                    return response;
                });
        }
        function  addOfferApi (principalId, offer){
            return Restangular.one(baseUrlOffreApi, principalId)
                .all('/')
                .customPOST(offer)
                .then(function (response) {
                    return response;
                });
        }

        function getAcquittal(principalId) {
            return Restangular.one(baseUrlAcquittal, principalId)
                .customGET()
                .then(function (response) {
                    return response;
                });
        }

        function addAcquittal(uploadDtoDo, uploadDtoLegalEntity) {
            // Create a combined object with both DTOs
            const requestBody = {
                acquittal: uploadDtoDo,
                legalEntityAcquittal: uploadDtoLegalEntity
            };
            return Restangular.one(baseUrlAcquittal)
                .all("/createOrUpdateAcquittalIfExist")
                .customPOST(requestBody)
                .then(function (response) {
                    return response;
                });
        }


        function getLegalEntityContext(legalEntityId, fluxType) {
            return Restangular.one(baseUrlAcquittal, legalEntityId)
                .all('/legalEntity')
                .customGET('',{fluxType: fluxType})
                .then(function (response) {
                    return response;
                });
        }

        function uploadAndDeployClientResource(uploadRequest) {
            const formData = new FormData();
            formData.append('resource', uploadRequest.resource);
            formData.append('metadata', new Blob([JSON.stringify({
                legalEntityId: uploadRequest.id,
                doId: uploadRequest.doId,
                country: uploadRequest.country,
                dematMode: uploadRequest.dematMode,
                legalIdentifier: uploadRequest.legalIdentifier,
                taxIdentifier: uploadRequest.taxIdentifier,
                fluxType: uploadRequest.fluxType,
                filters: uploadRequest.filters,
            })], {type: 'application/json'}));
            return $http({
                method: 'POST',
                url: CONF.apiContext + baseUrlPdfGeneration + '/upload',
                headers: {'Content-Type': undefined},
                data: formData,
                transformRequest: angular.identity
            }).then(function (response) {
                return response.data;
            });
        }

        function deleteClientResourceVersion(resourceUUID,deleteRequest) {
            return $http({
                method: 'DELETE',
                url: CONF.apiContext + baseUrlPdfGeneration + '/delete/' + resourceUUID,
                data: deleteRequest,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function downloadClientResourceVersion(resourceUUID) {
            return $http({
                method: 'GET',
                url: CONF.apiContext + baseUrlPdfGeneration + '/download/' + resourceUUID,
                headers: {'Content-Type': 'application/json'},
                responseType: 'arraybuffer',
            }).then(function (response) {
                let contentDisposition = response.headers('Content-Disposition');
                let filename = 'download.zip';

                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    let matches = /filename="([^"]*)"/.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1];
                    }
                }

                let blob = new Blob([response.data], {
                    type: 'application/zip',
                });
                FileSaver.saveAs(blob, filename);
                return response;
            });
        }

        function getClientResourceVersions(GetRequest) {
            return Restangular.all(baseUrlPdfGeneration).one('versions').customPOST(GetRequest);
        }
    }
})();
